export function ObservedSpellings({ spellings }: { readonly spellings: readonly string[] }) {
  if (spellings.length <= 1) return null;
  return <p className="observed-spellings">
    <strong>Observed OCR spellings:</strong> {spellings.join(', ')}. Uppercase I and lowercase l may be pixel-identical.
  </p>;
}
